import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private zone: NgZone) {
    this.zone.runOutsideAngular(() => {
      merge(
        fromEvent(window, 'online').pipe(map(() => true)),
        fromEvent(window, 'offline').pipe(map(() => false))
      ).subscribe(status =>
        this.zone.run(() => this.online$.next(status))
      );
    });
  }

  isOnline$() {
    return this.online$.asObservable();
  }

  isOnline() {
    return this.online$.value;
  }
}
